import { FormattedMessage } from 'react-intl';
import { cn } from '@/helpers/classnames';
import { toPeriodDate } from '@/helpers/periodEndDate';
import { IconArrowRight } from '@/icons';

interface PeriodDateRangeProps {
  from?: string;
  to?: string;
  className?: string;
}

export const PeriodDateRange = ({
  from,
  to,
  className,
}: PeriodDateRangeProps) => (
  <span className={cn('inline-flex items-center gap-3', className)}>
    <span>{from ? toPeriodDate(from) : '—'}</span>
    <IconArrowRight
      className="size-5 shrink-0 text-text-700"
      aria-hidden="true"
    />
    <span className="sr-only">
      {' '}
      <FormattedMessage defaultMessage="till" />{' '}
    </span>
    <span>{to ? toPeriodDate(to, 'end') : '—'}</span>
  </span>
);
